<template>
  <div class="kahiDetailContainer">
    <app-header v-bind:has-back-button="true"></app-header>
    <div class="kahiDetailMainContainer">
      <Suspense>
        <template #default>
          <async-kahi-detail></async-kahi-detail>
        </template>
        <template #fallback>
          <app-loading></app-loading>
        </template>
      </Suspense>
    </div>
  </div>
</template>

<script lang="ts" src="./KahiDetail.ts"></script>
<style scoped lang="scss" src="./KahiDetail.scss"></style>
